<template>
  <div class="offer-card">
    <!-- <div class="overlay"></div> -->
    <v-img
      :src="createImageUrl(offer)"
      @error="loadErr()"
      class="offer-card__header"
      :class="[imgErr ? 'placeholder' : '']"
      @click="showOffer(offer)"
    >
      <v-btn text @click="deleteOffer()">
        <font-awesome-icon icon="trash" class="offer-card__header__trash" />
      </v-btn>
      <v-img
        :src="createMerchantUrl(offer)"
        v-if="offer.merchant.logo"
        class="offer-card__header__logo"
      />
    </v-img>
    <div class="offer-card__footer">
      <div class="offer-card__footer__info">
        <h1 v-if="!imgErr" class="offer-card__footer__info__name">{{ offer.merchant.name }}</h1>
        <h3 class="offer-card__footer__info__title">{{ offer.title }}</h3>
      </div>
      <v-btn text @click="showInfo(offer)" class="offer-card__footer__options">
        <font-awesome-icon icon="ellipsis-h" />
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: { offer: Object },

  data() {
    return {
      imgErr: false
    };
  },

  methods: {
    ...mapActions({
      deleteOne: "offers/deleteOffer",
      toggleInfoModal: "ui/infoModalState",
      toggleOfferModal: "ui/offerModalState",
      offerInfo: "offers/showInfo"
    }),

    async showInfo(offer) {
      await this.offerInfo(offer);
      this.toggleInfoModal();
    },

    async showOffer(offer) {
      console.log(offer);
      await this.offerInfo(offer);
      this.toggleOfferModal();
    },

    createImageUrl(offer) {
      return `${process.env.VUE_APP_IMAGE_URL}/offer/${offer.id}_${offer.image}`;
    },

    createMerchantUrl(offer) {
      return `${process.env.VUE_APP_IMAGE_URL}/merchant/${offer.merchant.id}_${offer.merchant.logo}`;
    },

    deleteOffer() {
      this.deleteOne(this.offer);
    },

    loadErr() {
      console.log("error");
      this.imgErr = true;
    }
  },

  computed: {
    ...mapState({
      merchants: state => state.merchants
    }),

    allMerchants() {
      return this.merchants.items;
    }
  }
};
</script>

<style lang="sass" scoped>
@import "@/styles/variables.sass"
@import "@/styles/mixins.sass"
@import "@/styles/base.sass"


.offer-card
  height: 250px
  width: 300px
  display: flex
  flex-flow: column
  background: $c-white
  border-radius: 15px
  padding: 10px
  margin: 8px
  transition: all .3s
  box-shadow: 0px -3px 3px rgba(0, 0, 0, .1)
  background-image: linear-gradient(to bottom left, $bg-color, 5%, lighten($bg-color, 20%))

  &:hover
    transform: scale(1.02)

  &:hover .overlay
    position: fixed
    height: 165px
    width: 95%
    backdrop-filter: blur(2px)
    border-radius: 10px
    z-index: 5
    transition: all .3s ease

  &__header
    border-radius: 10px
    border-bottom-right-radius: 0
    height: 130px

    &__trash
      position: relative
      left: -10px
      color: $c-white
      box-shadow: 0px -2px 2px rgba(0, 0, 0, .3)
      
    &__logo
      position: fixed
      top: 10px
      left: -110px
      border: 40px solid $c-white
      border-radius: 50%
      transform: scale(.2)
      z-index: 20

      @include for-size(phone-only)
        left: 100px
        top: 0

      @include for-size(tablet-portrait-up)
        left: 95px
        top: 0

  &__footer
    display: flex
    flex-flow: row
    justify-content: space-between

    &__info
      display: flex
      flex-flow: column

      &__name
        font: 
          size: 20px
          weight: 300
        padding: 10px 

      &__title
        font: 
          size: 12px
          weight: 300
        padding: 0 0 0 10px 
    
    &__options
      margin: 20px -5px 5px 0

// Conditional classes
.placeholder 
  width: 415px
  height: 150px
  background: $c-nobel
  background-image: url(../../assets/logo_white.png)
  background-repeat: no-repeat
  background-size: 100px
  background-position: 90px
  
</style>
